import dotProp from 'dot-prop-immutable'
import {
  LOAD_INFO_DASHBOARD_SUCCESS,
  ACTIVE_COURSE_SUCCESS,
  LOAD_PRICE_LIST_SUCCESS,
} from '../actions/types'

const handdleActiveCourse = (state, action) => {
  const buy = 1
  const notBuy = 4
  const active = action.payload.active === buy ? notBuy : buy
  const { products: currentProducts } = state
  const indexProducts = currentProducts.findIndex(product => product._id === action.payload._id)
  if (indexProducts > -1) {
    let newState = dotProp.set(state, `products.${indexProducts}.active`, active)
    return {
      ...newState,
    }
  }
  return {
    ...state,
  }
}

const initialState = {
  maxPage: 0,
  products: [],
  priceList: [],
  actives: [
    'ยกเลิก',
    'สำเร็จ',
    'รอการประมวลผล',
    'กำลังตรวจสอบ',
  ],
}

const instructor = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_INFO_DASHBOARD_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case ACTIVE_COURSE_SUCCESS:
      return handdleActiveCourse(state, action)
    case LOAD_PRICE_LIST_SUCCESS:
      return {
        ...state,
        priceList: action.payload,
      }
    default:
      return state
  }
}

export default instructor



// WEBPACK FOOTER //
// ./src/reducers/instructor.js